export default __webpack_public_path__ + "static/media/hostnet.f806ba50.svg";